module.exports = __webpack_public_path__ + "img/1-01-01.7bf45a83.png";